import React from 'react';
import GameLoader from './components/GameLoader';
import './App.css';

function App() {
  return (
    <div className="w-full h-screen bg-black">
      <GameLoader />
    </div>
  );
}

export default App;
